import React, {Component} from 'react';
import Styles from './style.css';
import {userRegister} from "../../services/userRegister";
import {tokenRegister} from "../../services/tokenRegister";
import {langRegister} from "../../services/langRegister";
import {imagesRegister} from "../../services/imagesRegister";
import {quotesRegister} from "../../services/quotesRegister";
import {cartRegister} from "../../services/cartRegister"
import cx from "classnames";
import ModalLang from "../modal-lang/component";
import ModalLeave from "../modal-leave/component";
import ModalVideo from "../modal-video/component";
import ModalMarket from "../modal-market/component";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {dataRegister} from "../../services/dataRegister";
import {agentRegister} from "../../services/agentRegister";

class BoosterHeaderMobile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            user: {},
            options: {
                home: false,
                advertise: false,
                about: false
            },
            menu: false,
            layout: false,
            dropwdown: false,
            temp_lang: null,
            language: false,
            leave: false,
            home: false,
            profile: false,
            market: null,
            marketModal: false,
            temp_market: null,
            languages: [],
            markets: [],
            temp_option: null,
            private: false
        };
        this._lang = this._lang.bind(this);
        this._leave = this._leave.bind(this);
        this._setVideo = this._setVideo.bind(this);
    };

    componentWillMount() {
        this._updateLayout();
        this._updateUser();
        this._updateLang();
        this._checkPrivate();
        this._updateLanguages();
    }

    _updateLang(){
        this.setState({
            lang: langRegister.lang()
        });
    }

    _updateLayout() {
        try {
            this.setState({layout: this.props.layout});
        } catch (e) {}
    }

    _updateUser() {
        let user = userRegister.get();
        if(user){
            this.setState({
                user: user
            });
        }
    }

    _updateLanguages(){
        let languages = JSON.parse(salesChannelRegister.get('languages'));
        if(Array.isArray(languages)){
            this.setState({languages: languages});
        }
    }

    _checkPrivate(){
        if(salesChannelRegister.get("private")){
            this.setState({private: salesChannelRegister.get("private")});
        }
    }

    _signout() {
        if(this.state.user){
            if(this.state.user.admin){
                this.setState({home: true, leave: true});
            }else{
                userRegister.remove();
                tokenRegister.remove();
                agentRegister.remove();
                window.location.reload();
            }
        }else{
            userRegister.remove();
            tokenRegister.remove();
            agentRegister.remove();
            window.location.reload();
        }
    }

    _openMenu() {
        this.setState({menu: true});
    }

    _closeMenu() {
        this.setState({menu: false});
    }

    _open(option) {
        this.state.options[option] = !this.state.options[option];
        this.setState({options: this.state.options});
    }

    list(){
        window.location.replace("https://"+dataRegister.getDomain());
    }

    _go(option){
        if (this.props.props.location.pathname.indexOf("booster") !== -1 && this.props.props.location.pathname.indexOf("booster/confirmation") === -1) {
            this.setState({leave: true, home: true, temp_option: option});
        }else{
            try {
                this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + option);
                this._closeMenu();
            } catch (e) {}
        }
    }

    _signup() {
        try {
            this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/signup/image");
            this._closeMenu();
        } catch (e) {}
    }

    _profile() {
        if (this.props.props.location.pathname.indexOf("booster") !== -1 && this.props.props.location.pathname.indexOf("booster/confirmation") === -1) {
            this.setState({leave: true, profile: true});
        }else{
            try {
                this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/campaigns/running");
                this._closeMenu();
            } catch (e) {}
        }
    }

    _login() {
        try{
            if(this.props.props.location.pathname.indexOf("login") !== -1){
                this._closeMenu();
            }else{
                if(this.props.props.location.pathname.indexOf("booster") !== -1){
                    if(!this.state.private){
                        this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/login" + "?from_path=" + this.props.props.location.pathname);
                    }else{
                        this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/login");
                    }
                }else{
                    this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/login");
                }
            }
        }catch (e) {
            this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/login");
        }
    }

    _lang(lang){
        if(lang){
            langRegister.set(lang);
            cartRegister.remove();
            quotesRegister.remove();
            imagesRegister.remove();
            if(this.props.props.location.pathname.indexOf("images") !== -1){
                this.props.props.history.replace("/" + salesChannelRegister.get('market') + "/" + langRegister.lang());
                window.location.reload();
            }else{
                this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang());
            }
        }else{
            this.setState({language: false});
        }
    }

    _setLang(prop){
        if(prop.toLowerCase() !== langRegister.lang().toLowerCase()){
            if(this.props.props.location.pathname.indexOf("booster") !== -1 && this.props.props.location.pathname.indexOf("booster/confirmation") === -1){
                this.setState({language: true, temp_lang: prop, dropdown: false});
            }else{
                let string = "/" + salesChannelRegister.get('market') + "/" + langRegister.lang();
                let re = new RegExp(string,"g");
                let url = this.props.props.location.pathname.replace(re,'');
                langRegister.set(prop);
                this.props.props.history.replace("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + url);
                window.location.reload();
            }
        }else{
            this.setState({dropdown: false});
        }
    }

    _setVideo(value){
        this.setState({video: value});
    }

    _leave(value){
        if(value){
            if(this.state.home){
                try {
                    if(this.state.user.admin){
                        imagesRegister.remove();
                        cartRegister.remove();
                        quotesRegister.remove();
                    }
                }catch (error){}
                try {
                    if(this.state.temp_option){
                        this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + this.state.temp_option);
                    }else{
                        this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/images");
                    }
                } catch (e) {}
            }else if(this.state.profile){
                this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/campaigns/running");
            }else{
                if(this.props.props.location.pathname.indexOf("image") !== -1){
                    window.location.reload();
                }else{
                    this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/images");
                }
            }
        }else{
            this.setState({leave: false});
        }
    }

    _renderLanguage(lang){
        let value = "";
        for(let i = 0; i < this.state.languages.length; i++){
            if(this.state.languages[i].code === lang){
                value = this.state.languages[i].names[langRegister.lang()];
            }
        }
        return value;
    }

    _home(){

    }

    _terms(value){
        window.open('https://legal.'+dataRegister.domain+"/"+ salesChannelRegister.get('market') + "/" + langRegister.lang() + "/"+value+"/" + salesChannelRegister.get('name'), '_blank');
    }

    _help(){
        window.open('https://help.'+dataRegister.domain+"/"+ salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name'), '_blank');
    }

    _renderText(item) {
        return langRegister.get("mobile-menu", item);
    }

    renderFacebookPageLink(){
        try {
            if(window.location.href.indexOf("propertybooster") !== -1){
                return 'https://www.facebook.com/uae.propertybooster'
            }else if(window.location.href.indexOf("boostabostad") !== -1){
                return 'https://www.facebook.com/boostabostad'
            }else if(window.location.href.indexOf("yieldlock") !== -1){
                return 'https://www.facebook.com/yieldlock'
            }else{
                return undefined
            }
        }catch (e) {
            return undefined
        }
    }

    renderInstagramPageLink(){
        try {
            if(window.location.href.indexOf("propertybooster") !== -1){
                return 'https://www.instagram.com/uae.propertybooster'
            }else if(window.location.href.indexOf("boostabostad") !== -1){
                return 'https://www.instagram.com/boostabostad'
            }else if(window.location.href.indexOf("yieldlock") !== -1){
                return 'https://www.instagram.com/yieldlock'
            }else{
                return undefined
            }
        }catch (e) {
            return undefined
        }
    }

    render() {
        return (
            <div>
                <div className={
                    cx(Styles.menu,
                        {
                            [Styles.menuOpen]: this.state.menu,
                        })
                }>
                    {
                        this.state.language &&
                        <ModalLang setLang={this._lang} lang={this.state.temp_lang} props={this.props}/>
                    }
                    {
                        this.state.leave &&
                        <ModalLeave setLeave={this._leave} props={this.props}/>
                    }
                    {
                        this.state.video &&
                        <ModalVideo setVideo={this._setVideo} props={this.props}/>
                    }
                    <div className={Styles.menuInner}>
                        <img onClick={() => this._home()} className={Styles.menuInnerLogo}
                             src={salesChannelRegister.get('logo_mobile')}/>
                        {
                            !this.state.layout &&
                            <img className={Styles.menuInnerFigure}
                                 src={require("../../assets/images/figure_mobile_one.png")}/>
                        }
                        {
                            salesChannelRegister.get("name") !== "yieldlock" &&
                            tokenRegister.get() && !this.state.user.reseller && !this.state.user.inhouse &&
                            <img onClick={() => this._profile()} className={Styles.menuInnerUserIcon}
                                 src={require("../../assets/images/user_icon.svg")}/>
                        }
                        {
                            salesChannelRegister.get("name") === "yieldlock" &&
                            tokenRegister.get() && !this.state.user.reseller && !this.state.user.inhouse &&
                            <img onClick={() => this._profile()} className={Styles.menuInnerUserIcon}
                                 src={require("../../assets/images/user_icon_yl.svg")}/>
                        }
                        {
                            salesChannelRegister.get("name") !== "yieldlock" &&
                            tokenRegister.get() && (this.state.user.reseller || this.state.user.inhouse) &&
                            <img onClick={() => this._profile()} className={Styles.menuInnerUserIcon}
                                 src={require("../../assets/images/user_icon_reseller.svg")}/>
                        }
                        {
                            salesChannelRegister.get("name") === "yieldlock" &&
                            tokenRegister.get() && (this.state.user.reseller || this.state.user.inhouse) &&
                            <img onClick={() => this._profile()} className={Styles.menuInnerUserIcon}
                                 src={require("../../assets/images/user_icon_reseller_yl.svg")}/>
                        }

                        {
                            salesChannelRegister.get('name') !== "yieldlock" &&
                            <img onClick={() => this._closeMenu()} className={Styles.menuInnerClose}
                                 src={require("../../assets/images/cross_icon.png")}/>
                        }
                        {
                            salesChannelRegister.get('name') === "yieldlock" &&
                            <img onClick={() => this._closeMenu()} className={Styles.menuInnerClose} src={require("../../assets/images/close_icon_yl.svg")}/>
                        }

                        <div className={Styles.menuInnerOptions}>
                            <div onClick={() => this.list()} className={cx(Styles.menuInnerOptionsItem)}>
                                <div className={Styles.menuInnerOptionsItemText}>{this._renderText("item_1")}</div>
                            </div>
                            {
                                salesChannelRegister.get('name') !== "yieldlock" &&
                                <div onClick={() => this._go('/')}  className={cx(Styles.menuInnerOptionsItem)}>
                                    <div className={Styles.menuInnerOptionsItemText}>{this._renderText("item_22")}</div>
                                </div>
                            }
                            {
                                salesChannelRegister.get('name') === "yieldlock" &&
                                <div onClick={() => this._go('/')}  className={cx(Styles.menuInnerOptionsItem)}>
                                    <div className={Styles.menuInnerOptionsItemText}>Yieldlock</div>
                                </div>
                            }
                            <div onClick={() => this._go('/about')}  className={cx(Styles.menuInnerOptionsItem)}>
                                <div className={Styles.menuInnerOptionsItemText}>{this._renderText("item_8")}</div>
                            </div>
                            <a href={"mailto:support@"+salesChannelRegister.get("name")+"."+salesChannelRegister.get("market")+"?Subject=" + this._renderText("item_23")} target="_top" className={Styles.menuInnerOptionsItem}>
                                <div className={Styles.menuInnerOptionsItemText}>{this._renderText("item_9")}</div>
                            </a>
                            <div onClick={() => this._go('/reseller')}  className={
                                cx(Styles.menuInnerOptionsItem,
                                    {
                                        [Styles.menuInnerOptionsItemLast]: true
                                    })
                            }>
                                <div className={Styles.menuInnerOptionsItemText}>{this._renderText("item_10")}</div>
                            </div>
                            <div className={Styles.dropdown}>
                                <select className={Styles.dropdownSelection} value={this.state.lang} onChange={(event) => this._setLang(event.target.value)}>
                                    {
                                        this.state.languages.map((item, key) => {
                                            return(
                                                <option key={key} value={item.code}>{item.names[langRegister.lang()]}</option>
                                            )
                                        })
                                    }
                                </select>
                                <div className={Styles.dropdownText}>
                                    {this._renderLanguage(this.state.lang)}
                                </div>
                                <img className={Styles.dropdownArrow} src={require("../../assets/images/arrow_grey.svg")}/>
                            </div>

                            <div className={Styles.divider}/>
                            {
                                !this.state.private &&
                                <div onClick={() => this._signup()} className={Styles.button}>
                                    {this._renderText("item_11")}
                                </div>
                            }
                            {
                                this.state.user.email &&
                                <div onClick={() => this._signout()} className={Styles.button}>
                                    {this._renderText("item_12")}
                                </div>
                            }
                            {
                                !this.state.user.email &&
                                <div onClick={() => this._login()} className={Styles.button}>
                                    {this._renderText("item_13")}
                                </div>
                            }
                            <div className={Styles.socialIcons}>
                                    <a className={Styles.socialIcon} href={this.renderFacebookPageLink()} target={"_blank"}>
                                        <img className={Styles.socialIconFb}
                                             src={require("../../assets/images/facebook_icon.png")}/>
                                    </a>
                                    <a className={Styles.socialIcon} href={this.renderInstagramPageLink()} target={"_blank"}>
                                        <img className={Styles.socialIconInstagram}
                                             src={require("../../assets/images/instagram_icon.png")}/>
                                    </a>
                                {
                                    false &&
                                    <div className={Styles.socialIcon}>
                                        <img className={Styles.socialIconLinkedIn}
                                             src={require("../../assets/images/linkedin_icon.png")}/>
                                    </div>
                                }
                                {
                                    false &&
                                    <div className={Styles.socialIcon}>
                                        <img className={Styles.socialIconTwitter}
                                             src={require("../../assets/images/twitter_icon.png")}/>
                                    </div>
                                }
                            </div>
                            <div className={Styles.terms}>
                                <span onClick={() => this._terms("terms")}>{this._renderText("item_14")}</span> | <span onClick={() => this._terms("privacy")}>{this._renderText("item_15")}</span> | <span onClick={() => this._terms("acceptance")}>{this._renderText("item_16")}</span>
                            </div>
                            <div style={{width: "100%", height: "200px"}}/>
                        </div>
                    </div>
                </div>
                {
                    this.state.menu &&
                    <div className={Styles.overlay}/>
                }
            </div>
        );
    }
}

export default BoosterHeaderMobile;


// WEBPACK FOOTER //
// ./src/components/booster-header-mobile/component.js